import { render, staticRenderFns } from "./HorseSaillies.vue?vue&type=template&id=1f2358ff"
import script from "./HorseSaillies.vue?vue&type=script&lang=js"
export * from "./HorseSaillies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports